(() => {
  const LIST_SELECTOR = '[data-limited-package-list]';

  class LimitedPackageList {
    constructor(container) {
      this.container = container;
      this.grid = container.querySelector('[data-limited-package-grid]');
      this.toggle = container.querySelector('[data-limited-package-retired-toggle]');
      this.emptyAvailableMessage = container.querySelector('[data-limited-package-empty-available]');
      if (!this.grid) return;

      this.cards = Array.from(this.grid.querySelectorAll('.limited-package-list__item'));
      if (this.cards.length === 0) return;

      this.sortCards();
      this.applyFilter();

      if (this.toggle) {
        this.toggle.addEventListener('change', () => this.applyFilter());
      }
    }

    sortCards() {
      const sortedCards = this.cards.slice().sort((leftCard, rightCard) => {
        const leftOrder = Number.parseInt(leftCard.dataset.packageSortOrder || '0', 10);
        const rightOrder = Number.parseInt(rightCard.dataset.packageSortOrder || '0', 10);
        if (leftOrder !== rightOrder) return leftOrder - rightOrder;

        const leftSeq = Number.parseInt(leftCard.dataset.packageSeq || '0', 10);
        const rightSeq = Number.parseInt(rightCard.dataset.packageSeq || '0', 10);
        return leftSeq - rightSeq;
      });

      const fragment = document.createDocumentFragment();
      sortedCards.forEach((card) => fragment.appendChild(card));
      this.grid.appendChild(fragment);
      this.cards = sortedCards;
    }

    applyFilter() {
      const showOnlyAvailable = this.toggle ? this.toggle.checked : true;

      this.cards.forEach((card) => {
        const packageState = card.dataset.packageState || 'active';
        card.hidden = showOnlyAvailable && packageState !== 'active';
      });

      if (this.emptyAvailableMessage) {
        const visibleCards = this.cards.filter((card) => !card.hidden).length;
        this.emptyAvailableMessage.hidden = !(showOnlyAvailable && visibleCards === 0);
      }
    }
  }

  const setupLimitedPackageLists = (root = document) => {
    root.querySelectorAll(LIST_SELECTOR).forEach((list) => {
      if (list.dataset.limitedPackageListBound === 'true') return;
      list.dataset.limitedPackageListBound = 'true';
      new LimitedPackageList(list);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupLimitedPackageLists());
  } else {
    setupLimitedPackageLists();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target) return;
    setupLimitedPackageLists(event.target);
  });
})();
